module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchablock", [["div",{"class":"row capcha","id":"captchaBlock","style":"display: none"},[["span",{"class":"reload-captcha icon-au_site-captcha_update text-color-3","id":"reload_captcha"}],["div",{"class":"common-input icon captcha"},[["input",{"type":"text","name":"captcha"}],["div",{"class":"border"},[["div",{"id":"captcha","class":"ico"}]]]]],["div",{"class":"error-message"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/captcha.tpl
// module id = 1155
// module chunks = 4